module.exports = __webpack_public_path__ + "img/arr-r-r.ba28c81b.png";